import React, { Component } from 'react'
import { injectIntl } from 'react-intl'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form, Button, Icon, Input, Tabs } from 'antd'
import { deleteSelectedAsset, MoveSelectedAsset, multipleOptionsIsDone } from '../../actions/ClientAction'
import { sendShareAsset } from '../../actions/AssetsShareAction'
import Breadcrumb from '../breadcrumb/Breadcrumb'
import { sendNotification } from '../../utils/index'
import Helper from '../helper/Helper'
import Tags from '../tags/Tags'

const { TextArea } = Input;
const { TabPane } = Tabs

export class CollectionMultipleFunction extends Component {
  constructor(props) {
    super(props)

    this.state = {
      folderId: '',
      emails: [],
      message: '',
      start: false,
      action: '',
      hasEmailError: false,
    }
  }

  componentDidMount() {
    const { folderselect } = this.props
    if (folderselect && folderselect !== '') {
      this.setState({
        folderId: folderselect
      })
    }
  }

  componentDidUpdate(prevProps) {
    const { action } = this.state

    switch (action) {
      case 'delete':

        break;
      case 'move':

        break;
      case 'share':
        const { sended, error, intl } = this.props
        const { start } = this.state

        if (!sended
          && error
          && prevProps.error !== error) {

          this.setState({
            start: false
          })

          sendNotification('error', intl, intl.formatMessage({ id: 'error_message' }))

        } else if (!sended
          && start) {
          sendNotification('success', intl, intl.formatMessage({ id: 'asset_has_been_shared' }))
          this.setState({
            start: false
          })
        }
        break;

      default:
        break;
    }
  }

  //encargado de eliminar assets seleccionados
  handleDeleteAssets = () => {
    const { keyCollection, workclient, data } = this.props

    data.forEach(r => {
      if (r.isCheckMultiple) {
        this.props.deleteSelectedAsset(keyCollection, workclient, r._id, true)
      }
    })

    this.handleIsDone()
  }

  handleEmails = tag => {
    this.setState({ emails: tag.tags.map(r => { return r.id }) })
  }

  //encargado de compartir assets seleccionados
  handleSendShared = () => {
    const { data, workclient, user, intl } = this.props
    const { message, emails, hasEmailError } = this.state

    if (hasEmailError) {
      this.setState({
        hasEmailError: false
      })
      return
    } else {
      if (emails.length > 0) {
        data.forEach(r => {
          if (r.isCheckMultiple) {
            this.props.sendShareAsset(workclient, user, { _id: r._id }, message, emails, true)
          }
        })
        this.setState({
          start: true
        })
      } else {
        sendNotification('error', intl, intl.formatMessage({ id: 'invalid_mail' }))
      }
    }

    this.handleIsDone()
  }

  //encargado de mover assets seleccionados
  handleMoveAsset = () => {
    const { data, workclient, keyCollection, folderselect, page, intl } = this.props
    const { folderId } = this.state

    //valida que alguno de los assets seleccionados de tipo folder no correspondan a la carpeta de destino
    if (data.find(r => r.isCheckMultiple && r._id === folderId)) {
      sendNotification('warning', intl, intl.formatMessage({ id: 'wrong_destination_folder' }))
      this.setState({
        folderId: ''
      })
      return
    }

    data.forEach(r => {
      if (r.isCheckMultiple) {
        if (folderId)
          this.props.MoveSelectedAsset(keyCollection, workclient, { _id: r._id }, folderId, folderselect, intl, page, true)
        else
          sendNotification('warning', intl, intl.formatMessage({ id: 'select_valid_destination' }))
        return
      }
    })
    this.handleIsDone()
  }


  handleFolderSelect = folderId => {
    const { data, intl } = this.props

    if (data.find(r => r.isCheckMultiple && r._id === folderId)) {
      sendNotification('warning', intl, intl.formatMessage({ id: 'wrong_destination_folder' }))
      this.setState({
        folderId: ''
      })
      return
    } else {
      this.setState({
        folderId
      })
    }
  }


  handleOnInputChange = (e) => {
    this.setState({
      message: e.target.value,
    })
  }

  handleIsDone = () => {
    const { keyCollection } = this.props
    this.props.multipleOptionsIsDone(keyCollection)
    this.setState({
      folderId: '',
      emails: [],
      message: '',
      start: false,
      action: '',
    })
  }

  handleError = (hasError) => {
    this.setState({
      hasEmailError: hasError
    })
  }

  render() {

    const { data, newColor, isMoving, intl } = this.props
    const { folderId, message, start } = this.state
    return (
      <Form>
        <span>Assets seleccionados:</span>
        <ul>
          {data.map((r, k) => {
            k++
            return <React.Fragment key={k}>
              {r.isCheckMultiple &&
                <li>{r.name}</li>
              }
            </React.Fragment>
          })}
        </ul>
        <Tabs defaultActiveKey="1" tabPosition="top">
          <TabPane tab="Mover" key="1">
            <Form.Item>
              <Breadcrumb
                title={intl.formatMessage({ id: 'breadcrumb_placeholder' })}
                placeholder={intl.formatMessage({ id: 'where_move_asset' })}
                value={folderId}
                handleFolderSelect={this.handleFolderSelect}
              />
            </Form.Item>
            <Form.Item>
              <Button
                loading={isMoving}
                type="primary"
                style={{ backgroundColor: newColor, borderColor: newColor }}
                onClick={this.handleMoveAsset}
              >{intl.formatMessage({ id: 'move_asset' })}<Icon type="export" />
              </Button>
            </Form.Item>
          </TabPane>
          <TabPane tab="Compartir" key="2">
            <div>
              <Form.Item>
                <span>{"Agregar Emails"}
                  <Helper
                    title={"helper_title"}
                    content={"helper_share_asset_content"}
                    trigger={`click`} />
                </span>
                <Tags
                  titleCustom='Agregar direcciones de correo'
                  placeholderCustom={intl.formatMessage({ id: "add_new_email" })}
                  validateIsEmail={true}
                  handleTags={this.handleEmails}
                  handleError={this.handleError}
                />
              </Form.Item>
              <Form.Item>
                <TextArea
                  placeholder={intl.formatMessage({ id: 'message' })}
                  rows='5'
                  value={message}
                  onChange={this.handleOnInputChange} />
              </Form.Item>
              <Form.Item>
                <Button loading={start} onClick={this.handleSendShared} type='primary' style={{ backgroundColor: newColor, borderColor: newColor }}>
                  <Icon type="share-alt" />
                  {intl.formatMessage({ id: "shared_share" })}
                </Button>
              </Form.Item>
            </div>
          </TabPane>
          <TabPane tab="Eliminar" key="3">
            <Button type="primary"
              onClick={this.handleDeleteAssets}
              style={{ backgroundColor: newColor, borderColor: newColor }}
            >{intl.formatMessage({ id: 'delete_asset' })}<Icon type="delete" /></Button>
          </TabPane>
        </Tabs>
      </Form>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { keyCollection } = ownProps
  let object
  switch (keyCollection) {
    case 'assetsRoot':
      object = {
        isMoving: state.assetsRoot.isMoving,
        isFetching: state.assetsRoot.isFetching,
        data: state.assetsRoot.data,
        itemSelected: state.assetsRoot.data.find(r => r.isSelected),
        folderselect: state.assetsRoot.folderselect,
        error: state.assetsRoot.error,
        activeView: state.assetsRoot.activeView,
      }
      break
    case 'assetsLastUploads':
      object = {
        isMoving: state.assetsLastUploads.isMoving,
        isFetching: state.assetsLastUploads.isFetching,
        data: state.assetsLastUploads.data,
        itemSelected: state.assetsLastUploads.data.find(r => r.isSelected),
        folderselect: state.assetsLastUploads.folderselect,
        error: state.assetsLastUploads.error,
        activeView: state.assetsLastUploads.activeView
      }
      break
    case 'assetsShared':
      object = {
        isMoving: state.assetsShared.isMoving,
        isFetching: state.assetsShared.isFetching,
        data: state.assetsShared.data,
        itemSelected: state.assetsShared.data.find(r => r.isSelected),
        folderselect: state.assetsShared.folderselect,
        error: state.assetsShared.error,
        activeView: state.assetsShared.activeView
      }
      break
    case 'assetsFavorites':
      object = {
        isMoving: state.assetsFavorites.isMoving,
        isFetching: state.assetsFavorites.isFetching,
        data: state.assetsFavorites.data,
        itemSelected: state.assetsFavorites.data.find(r => r.isSelected),
        folderselect: state.assetsFavorites.folderselect,
        error: state.assetsFavorites.error,
        activeView: state.assetsFavorites.activeView
      }
      break
    case 'assetsExplore':
      object = {
        isMoving: state.assetsExplore.isMoving,
        isFetching: state.assetsExplore.isFetching,
        data: state.assetsExplore.data,
        itemSelected: state.assetsExplore.data.find(r => r.isSelected),
        folderselect: state.assetsExplore.folderselect,
        error: state.assetsExplore.error,
        activeView: state.assetsExplore.activeView
      }
      break
    case 'searcher':
      object = {
        isMoving: state.searcher.isMoving,
        activeView: state.assetsShared.activeView,
      }
      break

    default:
      object = {}
      break
  }

  return {
    ...object,
    workclient: state.client.workclient,
    folderselect: state.assetsExplore.folderselect,
    user: state.authUser.user._id,
    isFetching: state.assetsShared.isFetching,
    error: state.assetsShared.error,
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    sended: state.assetsShared.sended,
  }
}

const mapDispatchToProps = {
  deleteSelectedAsset,
  MoveSelectedAsset,
  sendShareAsset,
  multipleOptionsIsDone
}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(CollectionMultipleFunction)))